<template>
    <UiModal
        :is-open="showAffiliateModal"
        title="Affiliate Disclosure"
        @close="closeModal()"
    >
        <template #content>
            <div class="flex w-full justify-center">
                <div class="prose">
                    <img
                        src="/images/affiliate-disclosure.png"
                        class="mx-auto w-1/3 mb-1"
                        alt="Affiliate Disclosure"
                    />

                    <p class="mb-5">
                        10xTravel is part of an affiliate sales network and
                        receives compensation for sending traffic to partner
                        sites, such as CreditCards.com. This compensation may
                        impact how and where links appear on this site. This
                        site does not include all financial companies or all
                        available financial offers. Terms apply to American
                        Express benefits and offers. Enrollment may be required
                        for select American Express benefits and offers. Visit
                        americanexpress.com to learn more.
                    </p>

                    <p>
                        <strong>Editors Note:</strong>
                        Opinions expressed here are author’s alone, not those of
                        any bank, credit card issuer, hotel, airline, or other
                        entity. This content has not been reviewed, approved or
                        otherwise endorsed by any of the entities included
                        within the post.
                    </p>
                </div>
            </div>
        </template>
    </UiModal>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppStore } from '@/store/app';
import UiModal from '@/components/ui/modal/ui-modal.vue';

export default {
    components: {
        UiModal,
    },
    computed: {
        ...mapState(useAppStore, ['showAffiliateModal']),
    },
    methods: {
        ...mapActions(useAppStore, ['setShowAffiliateModal']),
        closeModal() {
            this.setShowAffiliateModal(false);
        },
    },
};
</script>
